
import type { SVGProps } from 'react';
const SvgEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#email_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M0 12c0 6.617 5.383 12 12 12s12-5.383 12-12a.48.48 0 0 0-.96 0c0 6.087-4.953 11.04-11.04 11.04S.96 18.087.96 12 5.913.96 12 .96c1.813 0 3.61.449 5.198 1.298a.48.48 0 0 0 .453-.847A12 12 0 0 0 12 0C5.382 0 0 5.383 0 12m12.826-6.65c-3.84 0-7.104 2.944-7.104 7.419 0 4.004 2.747 6.019 5.986 6.019 1.152 0 2.185-.255 3.16-.805l-.445-1.06c-.707.393-1.649.68-2.565.68-2.662 0-4.82-1.674-4.82-4.886 0-3.748 2.786-6.182 5.638-6.182 3.094 0 4.5 2.015 4.5 4.5 0 1.957-1.065 3.16-2.073 3.16-.811 0-1.092-.536-.818-1.655l.694-3.44h-1.191l-.21.673h-.032c-.288-.562-.726-.804-1.276-.804-1.89 0-3.225 2.034-3.225 3.905 0 1.491.87 2.388 2.067 2.388.694 0 1.485-.465 1.976-1.106h.033c.144.811.873 1.243 1.792 1.243 1.603 0 3.5-1.492 3.5-4.416 0-3.33-2.165-5.632-5.587-5.632m.393 5.437-.425 2.4c-.491.61-.897.851-1.296.851-.595 0-1-.39-1-1.276 0-1.105.693-2.55 1.818-2.55.386 0 .664.176.903.575"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="email_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEmail;
